import React from "react";
import { FormattedMessage } from "react-intl";
import { ReactComponent as UploadFolderIcon } from "@/images/uploadingFolder.svg";
import { Progress, Button } from "antd";
import CheckedIcon from "@/images/checked.svg";

function UploadStatus({ percent, onClose }) {
  const isCompleted = percent === 100;
  return (
    <div id={"PeopleUploadLoader"}>
      <div className={"loader-content"}>
        <p style={{ fontWeight: "bold", color: "black" }}>
          {isCompleted ? (
            <FormattedMessage defaultMessage="Completed" id="App.Completed" />
          ) : (
            <FormattedMessage
              defaultMessage="Uploading contacts"
              id="App.Uploading.Contacts"
            />
          )}
        </p>
        <div className="loader--Body">
          {isCompleted ? (
            <img
              src={CheckedIcon}
              alt="CheckedIcon"
              style={{ display: "inline-block", height: 50, width: 50 }}
            />
          ) : (
            <div className="loader--BodyLeft">
              <UploadFolderIcon />
              <span className="numIndicator"> {percent}%</span>
            </div>
          )}

          {isCompleted ? (
            <span
              style={{
                color: "#0B7D1A",
                display: "inline-block",
                paddingLeft: 10,
                textAlign: "left",
              }}
            >
              <FormattedMessage
                id="App.ImportFromFile.Success"
                defaultMessage="Your file has been imported successfully!"
              />
            </span>
          ) : (
            <div>
              <p>
                <FormattedMessage
                  defaultMessage="Hang on tight!"
                  id="App.Msg.Hangon"
                />
              </p>
              <FormattedMessage
                id="App.Contacts.Upload.Msg.Wait"
                defaultMessage={"Please Wait , while we upload your contacts"}
              />
            </div>
          )}
        </div>
        <Progress
          showInfo={false}
          percent={percent}
          status={isCompleted ? "" : "active"}
        />
        <Button
          onClick={onClose}
          style={{
            //toggle visibility and opacity to avoid flickering
            visibility: isCompleted ? "visible" : "hidden",
            opacity: isCompleted ? 1 : 0,
            float: "right",
            minWidth: "auto",
          }}
        >
          <FormattedMessage id={"App.Close"} defaultMessage={"Close"} />
        </Button>
      </div>
    </div>
  );
}

export default UploadStatus;
